export const trending = [
  { rank: 1, title: "某顶流男星深夜取关三人：48小时时间线全复盘", slug: "top-male-star-night-unfollow", heat: 98240, tag: "娱乐圈", change: "up" },
  { rank: 2, title: "独家首发：某合作方内部聊天记录流出，事件出现关键转折", slug: "exclusive-chat-record", heat: 82150, tag: "首发追踪", change: "up" },
  { rank: 3, title: "百万粉网红直播口误：品牌方连夜撤下联名海报", slug: "web-celebrity-live-slip", heat: 87310, tag: "网红圈", change: "down" },
  { rank: 4, title: "男团合约风波升级：工作室深夜发文引粉丝集体刷屏", slug: "idol-group-contract", heat: 71980, tag: "娱乐圈", change: "up" },
  { rank: 5, title: "千万粉情侣博主突然清空合照：双方先后发文各执一词", slug: "influencer-couple-clear-photos", heat: 68840, tag: "情感瓜", change: "flat" },
  { rank: 6, title: "热播剧男女主被拍同框：剧组工作人员回应耐人寻味", slug: "drama-lead-same-frame", heat: 76540, tag: "影视瓜", change: "up" },
  { rank: 7, title: "带货一哥被质疑价格虚高：同款商品三方比价结果出炉", slug: "livestream-price-dispute", heat: 60230, tag: "网红圈", change: "down" },
  { rank: 8, title: "综艺未播片段流出：那句被剪掉的话成了最大悬念", slug: "variety-unaired-clip", heat: 61220, tag: "影视瓜", change: "flat" },
];

export const tickerItems = [
  "某顶流男星深夜取关三人，工作室全天未按惯例回应",
  "品牌旗舰店首页联名海报深夜被替换，官方仅称物料排期调整",
  "男团工作室深夜发文，通篇未提续约与解散等关键措辞",
  "千万粉情侣博主合照被集中清空，双方先后发文说法不一",
  "站内独家首发：某合作方聊天记录截图出现关键时间对应",
  "带货直播「全网最低」表述被比价长图质疑，差异幅度有限",
];